import { useEffect, useState } from "react";

/* Live "reps available" count for the landing hero + authed Homepage.
   - Hits GET /api/matchmaking/queue-count (public — no auth needed).
   - Polls every POLL_MS while the component is mounted + the tab is visible.
   - `count === null` means we haven't received our first response yet, so
     callers can show a subtle "…" placeholder instead of a bogus zero. */

const POLL_MS = 5000;
const API = process.env.REACT_APP_BACKEND_URL;

export function useQueueCount() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    let timeoutId = null;

    const tick = async () => {
      if (!alive) return;
      if (document.visibilityState === "hidden") {
        timeoutId = setTimeout(tick, POLL_MS);
        return;
      }
      try {
        const r = await fetch(`${API}/api/matchmaking/queue-count`);
        if (!alive) return;
        if (r.ok) {
          const data = await r.json();
          setCount(typeof data?.count === "number" ? data.count : 0);
        }
      } catch {
        // transient — try again on the next tick
      }
      if (!alive) return;
      timeoutId = setTimeout(tick, POLL_MS);
    };

    tick();
    const onVis = () => {
      if (document.visibilityState === "visible") {
        // Fire immediately when the tab comes back so the number is fresh.
        if (timeoutId) clearTimeout(timeoutId);
        tick();
      }
    };
    document.addEventListener("visibilitychange", onVis);

    return () => {
      alive = false;
      if (timeoutId) clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);

  return count;
}
